"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryDetail = void 0;
const kpi_header_1 = require("client/components/kpi-header");
const kpi_child_1 = require("client/components/kpi-header/kpi-child");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/inventory/modules/inventory-detail/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
require("./inventory-detail.less");
const details_1 = require("./tabs/details");
const sites_1 = require("./tabs/sites");
let InventoryDetail = class InventoryDetail extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.withPadding = true;
        const [siteId, inventoryId] = this.props.params;
        this.addTab("Details", () => `/formulary/${siteId}/${inventoryId}`, /^\/formulary\/(\d+)\/(\d+)?$/, details_1.DetailsTab);
        store_3.usersStore.permissions.ReadPharmacies &&
            this.addTab("pharmacies", () => `/formulary/${siteId}/${inventoryId}/pharmacies`, /^\/formulary\/(\d+)\/(\d+)\/pharmacies$/, sites_1.SitesTab);
    }
    async componentDidMount() {
        const [siteIdFromParams, inventoryId] = this.props.params;
        const siteId = store_3.usersStore.user.value.siteUser
            ? store_3.usersStore.user.value.site.id
            : siteIdFromParams;
        if (inventoryId) {
            await store_1.inventoryDetailStore.readInventory(Number(inventoryId), Number(siteId));
            this.showTabs(true);
        }
        else {
            this.showTabs(false);
            // // Account for legacy route transition from refill alert.
            // const siteId = usersStore.user.value.siteUser
            //   ? usersStore.user.value.site.id
            //   : 0;
            // const inventoryId = siteIdFromParams;
            // RouteManager.transitionTo(`/formulary/${siteId}/${inventoryId}`);
        }
    }
    async componentWillReceiveProps(props) {
        const oldInventoryId = Number(this.props.params[1]);
        const newInventoryId = Number(props.params[1]);
        if (newInventoryId && oldInventoryId !== newInventoryId) {
            await store_1.inventoryDetailStore.readInventory(newInventoryId);
            store_1.inventoryDetailStore.currentInventoryId = newInventoryId;
        }
        if (newInventoryId) {
            this.showTabs(true);
        }
        else {
            this.showTabs(false);
        }
    }
    render() {
        const [siteId] = this.props.params;
        const shouldIndicateMasterView = store_3.usersStore.user.value.user && Number(siteId) === 0;
        const currentSiteSelected = store_2.sitesListStore.sites
            ? store_2.sitesListStore.sites.value.find(site => site.id === Number(siteId))
            : null;
        let siteDisplayName;
        if (currentSiteSelected) {
            siteDisplayName = currentSiteSelected.displayName;
        }
        const storeLoaded = !!store_1.inventoryDetailStore.inventory.value;
        const fdbNdc = storeLoaded &&
            store_1.inventoryDetailStore.inventory.value.package.replace(/-/g, "");
        const fdbLink = () => (React.createElement("a", { onClick: () => router_1.RouteManager.transitionTo(`/formulary/search?ndc=${fdbNdc}`) }, "View FDB Data"));
        return (React.createElement("div", { className: "inventory-detail" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: store_1.inventoryDetailStore.name, subLabel: store_1.inventoryDetailStore.inventory.value &&
                        store_1.inventoryDetailStore.inventory.value.package, subLabel2: fdbLink() }),
                store_3.usersStore.permissions.ReadMaster && (React.createElement(kpi_child_1.KpiChild, null, !store_1.inventoryDetailStore.shouldHideViewIndication ? (React.createElement("span", { className: "master-view-indicator" }, shouldIndicateMasterView ? ("Master Formulary View") : (React.createElement(React.Fragment, null,
                    siteDisplayName ? "" : `Viewing Site ID: `,
                    React.createElement(router_1.Link, { to: `/pharmacies/${siteId}` }, siteDisplayName || siteId))))) : null))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "inventory-detail__tabs" }, super.render()))));
    }
};
InventoryDetail = __decorate([
    mobx_react_1.observer
], InventoryDetail);
exports.InventoryDetail = InventoryDetail;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/inventory-detail.tsx
// module id = 3462
// module chunks = 0